
    import * as React from 'react';

    const Home16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Home_16_svg__Icons/Home/16" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M2,14 L2,5.75234522 L8,2 L14,5.75234522 L14,7 L13.999,6.999 L13.999,13 L14,13 L14,14 L10,14 L6,14 L2,14 Z M8,3.24765478 L3,6.375 L3,13 L6,13 L6,9 L6.00548574,8.85073766 C6.08183488,7.81587779 6.9456382,7 8,7 C9.1045695,7 10,7.8954305 10,9 L10,13 L12.999,13 L12.999,6.374 L8,3.24765478 Z M8,8 C7.47567654,8 7.04105398,8.40547321 7.00481105,8.88746517 L7,9 L7,13 L9,13 L9,9 C9,8.44771525 8.55228475,8 8,8 Z" id="Home_16_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Home16.displayName = 'Home16';

    export default Home16;
  